/* 遵循ant-design-pro定义接口规范 */
/* https://github.com/ant-design/ant-design-pro */

import { CORE_AXIOS, type Http } from "@/core"
import { container } from "tsyringe"
import type { InvoiceModel } from "./interface/InvoiceInterface"
// import type { CompanyRegisterState } from "./interface/AuthInterface"

/** GET all invoice info */
export async function InvoiceGet(): Promise<{invoices:InvoiceModel[]}> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get('/v1/api/ums/invoices')
}

/** ADD invoice info */
export async function invoiceAdd(data:InvoiceModel):Promise<InvoiceModel>{
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.post('/v1/api/ums/invoices',data) 
}

/** UPDATE invoice Default */
export async function invoiceUserDefault(data:InvoiceModel):Promise<InvoiceModel>{
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.put('/v1/api/ums/invoices/'+data.id,data) 
}

/** DELETE invoice info */
export async function invoiceDeleteInfo(id:string | number):Promise<InvoiceModel>{
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.delete('/v1/api/ums/invoices/'+id) 
}


